// extracted by mini-css-extract-plugin
export default {"carousel":"Home_carousel__GhB6v"};